import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getShopPluginApi } from '@app/pages/checkout-app/utils';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class ShopPluginApi {
  private readonly API_URL = getShopPluginApi();
  constructor(
    private http: HttpClient,
    private apiService: ApiService,
  ) {}

  get(path: string, options = {}): Observable<any> {
    return this.http.get(this.API_URL + path, { ...options, headers: this.getHeaders() });
  }
  public getHeaders() {
    return {
      Authorization: `Bearer ${this.apiService.jwtToken}`,
    };
  }
  post(path: string, body: any, options = {}): Observable<any> {
    return this.http.post(this.API_URL + path, body, { ...options, headers: this.getHeaders() });
  }
  patch(path: string, body: any, options = {}): Observable<any> {
    return this.http.patch(this.API_URL + path, body, { ...options, headers: this.getHeaders() });
  }
  delete(path: string, options = {}): Observable<any> {
    return this.http.delete(this.API_URL + path, { ...options, headers: this.getHeaders() });
  }
}
